import React from 'react';
import { Title } from 'react-admin';
import { Card, CardContent, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    card: { margin: '1em' },
    header: {
        padding: '16px 24px',
        backgroundColor: '#e53935',
        color: 'white',
    },
    row: {
        display: 'flex',
        padding: '8px 0',
        borderBottom: '1px solid #eee',
    },
    key: {
        fontWeight: 600,
        width: 280,
        color: '#4C3920',
        fontFamily: 'monospace',
    },
    value: {
        fontFamily: 'monospace',
        color: '#333',
    },
});

const vars = [
    'REACT_APP_HASURA_BACKEND',
    'REACT_APP_ENV',
    'REACT_APP_TABLE_PREFIX',
];

export const EnvInfo = () => {
    const classes = useStyles();
    return (
        <Card className={classes.card}>
            <Title title="Ambiente: STAGING" />
            <Typography variant="h6" className={classes.header}>
                Ambiente: STAGING
            </Typography>
            <CardContent>
                {vars.map(key => (
                    <div key={key} className={classes.row}>
                        <span className={classes.key}>{key}</span>
                        <span className={classes.value}>{process.env[key] || '(non impostata)'}</span>
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};
